import axios from '../axiosInstances/axiosInstance';

export const updateCommunicationPreferences = (preferences) => {
  return axios.put(`/users/communicationPreferences`, preferences);
};
